import {
  shareModalHandleSelection,
  shareModalSelectChannel,
  shareModalSelectDM,
} from 'actions/multiShare';
import { SLACK_MODAL_PICK_PANE_CLICKED } from 'constants/events';
import { CHANNEL, DM } from 'constants/slack';
import * as analytics from 'utilities/analytics';

export function shareModalClickHandler(type, idList) {
  return (dispatch, getState) => {
    const { multi_share: multiShare } = getState();
    const indexes = [];

    let newChannels = null;
    let newSelections = Array.from(multiShare.search_content);

    analytics.track(SLACK_MODAL_PICK_PANE_CLICKED, { type });

    if (!Array.isArray(idList)) {
      idList = [idList];
    }

    switch (type) {
      case CHANNEL:
        newChannels = multiShare.channel_content.map((info, ind) => {
          if (idList.includes(info.channel.id)) {
            indexes.push(ind);

            return {
              ...info,
              active: !info.active,
            };
          }

          return info;
        });

        indexes.forEach(ind => {
          if (newChannels[ind].active) {
            newSelections.push({ ...newChannels[ind].channel, type: CHANNEL });
          } else {
            newSelections = newSelections.filter(
              channel => channel.id !== newChannels[ind].channel.id
            );
          }
        });

        dispatch(shareModalHandleSelection(newSelections));
        dispatch(shareModalSelectChannel(newChannels));
        break;
      case DM:
        newChannels = multiShare.dm_content.map((info, ind) => {
          if (idList.includes(info.dm.id)) {
            indexes.push(ind);

            return {
              ...info,
              active: !info.active,
            };
          }

          return info;
        });

        indexes.forEach(ind => {
          if (newChannels[ind].active) {
            newSelections.push({ ...newChannels[ind].dm, type: DM });
          } else {
            newSelections = newSelections.filter(
              channel => channel.id !== newChannels[ind].dm.id
            );
          }
        });

        dispatch(shareModalHandleSelection(newSelections));
        dispatch(shareModalSelectDM(newChannels));
        break;
      default:
        return;
    }
  };
}
